module.exports = __webpack_public_path__ + "img/source_main-con02.30f315b2.png";